import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  labelField: {
    fontWeight: 300,
    paddingBottom: 5,
    lineHeight: '30px',
  },
  valueContainer: {
    color: '#2D2D2D',
    padding: '16.5px 15px',
    background: '#fff',
    border: '1px solid #ABAFB3',
    borderRadius: '10px',
    height: theme.spacing(26),
  },
  value: {
    fontSize: 16,
    fontWeight: 600,
  },
}));
